 <div>
    <!-- Create Button Always Visible -->
    <div class="mb-3">
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark p-1"
        data-bs-toggle="modal"
        data-bs-target="#create_subentity_modal"
        @click="open_create_subentity_modal">
        Create Sub-Entities
      </button>
    </div>

    <!-- GlobalTable Implementation -->
    <GlobalTable
      :headers="table_headers"
      :data="table_safe_form_list"
      table_id="subentity_management_table">
      <template #actions="{ row }">
        <button
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          data-bs-toggle="modal"
          data-bs-target="#edit_subentity_modal"
          @click="open_edit_subentity_modal(row)">
          Edit
        </button>
      </template>
    </GlobalTable>
  </div>

    <!-- Create Sub-Entity Modal -->
  <teleport to="body">
    <div class="modal fade" id="create_subentity_modal" tabindex="-1" aria-labelledby="create_subentity_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs" id="create_subentity_label">Create Sub-Entity</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

            <div class="modal-body">
              <!-- Sub-Entity Name -->
              <div class="modal-form-group form-group mb-3">
                <label for="subentity_name" class="modal-form-label form-label text-xxs">Sub-Entity Name:</label>
                <input
                  type="text"
                  v-model="subentity_name"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                  placeholder="Enter Sub-Entity Name Here">
                <small class="text-danger p-2 text-xxs fw-bold d-none subentity-name-messages">Please enter a sub-entity name</small>
                <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
              </div>

              <!-- Sub-Entity Description -->
              <div class="modal-form-group form-group mb-3 d-none">
                <label for="subentity_description" class="modal-form-label form-label text-xxs">Sub-Entity Description:</label>
                <textarea
                  v-model="subentity_description"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                  placeholder="Enter Sub-Entity Description Here"
                  rows="4"
                  cols="10">
                </textarea>
                <small class="text-danger p-2 text-xxs fw-bold d-none subentity-description-messages">Please enter a description</small>
                <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
              </div>
            </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm px-3 shadow text-xxs"
              @click="create_subentity">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

    <!-- Edit Sub-Entity Modal -->
  <teleport to="body">
    <div class="modal fade" id="edit_subentity_modal" tabindex="-1" aria-labelledby="edit_subentity_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs" id="edit_subentity_label">Edit Sub-Entity</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

            <div class="modal-body">
              <!-- Sub-Entity Name -->
              <div class="modal-form-group form-group mb-3">
                <label for="edit_subentity_name" class="modal-form-label form-label text-xxs">Sub-Entity Name:</label>
                <input
                  type="text"
                  v-model="edit_subentity_name"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                  placeholder="Enter Sub-Entity Name">
                <small class="text-danger p-2 text-xxs fw-bold d-none edit-name-messages">Please enter a sub-entity name</small>
              </div>

              <!-- Sub-Entity Description -->
              <div class="modal-form-group form-group mb-3 d-none">
                <label for="edit_subentity_description" class="modal-form-label form-label text-xxs">Sub-Entity Description:</label>
                <textarea
                  v-model="edit_subentity_description"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                  placeholder="Enter Sub-Entity Description"
                  rows="4"
                  cols="10">
                </textarea>
                <small class="text-danger p-2 text-xxs fw-bold d-none edit-description-messages">Please enter a description</small>
              </div>
            </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm px-3 shadow text-xxs"
              @click="update_subentity">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
</teleport>